<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    
    <div class="modal-content">
      <h3>Cod QR pentru: {{ title }}</h3>
      <p>Scanați acest cod cu aplicația mobilă OSACE.</p>
      
      <QrCode
        :text="qrValue"
        :size="800" level="H"
      />
      
      <button @click="$emit('close')" class="close-button">Închide</button>
    </div>
  </div>
</template>

<script setup>
// Importăm componenta de cod QR
import QrCode from 'vue-qrcode-component';

// Definim ce date primește (codul și titlul)
defineProps({
  qrValue: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: 'Eveniment'
  }
});

// Definim evenimentul de închidere
defineEmits(['close']);
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-content {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0,0,0,0.3);
}
.modal-content h3 {
  margin-top: 0;
  color: #0E3035;
}
/* Stilul pentru codul text a fost șters, deoarece nu mai e necesar */
.close-button {
  margin-top: 25px;
  background-color: #1C748C;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
}
</style>